<template>
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5 0C7.18629 0 4.5 2.68629 4.5 6V6.12602C2.77477 6.57006 1.5 8.13616 1.5 10V16C1.5 18.2091 3.29086 20 5.5 20H15.5C17.7091 20 19.5 18.2091 19.5 16V10C19.5 8.13616 18.2252 6.57006 16.5 6.12602V6C16.5 2.68629 13.8137 0 10.5 0ZM10.5 2C12.7091 2 14.5 3.79086 14.5 6H6.5C6.5 3.79086 8.29086 2 10.5 2ZM5.5 8C4.39543 8 3.5 8.89543 3.5 10V16C3.5 17.1046 4.39543 18 5.5 18H15.5C16.6046 18 17.5 17.1046 17.5 16V10C17.5 8.89543 16.6046 8 15.5 8H5.5ZM10.5 10C9.39543 10 8.5 10.8954 8.5 12C8.5 12.7403 8.9022 13.3866 9.5 13.7324V15C9.5 15.5523 9.94772 16 10.5 16C11.0523 16 11.5 15.5523 11.5 15V13.7324C12.0978 13.3866 12.5 12.7403 12.5 12C12.5 10.8954 11.6046 10 10.5 10Z"
      fill="black"
      fill-opacity="0.3"
    />
  </svg>
</template>
